import adminReducer from "./reducers";

export default adminReducer;